export function useMainnet() {
  return [true];
}
